export const elementsQuestions = [
  { name: 'The Elements', key: 'elements' },
  { name: 'Assets', key: 'assets' },
  { name: 'Liabilities', key: 'liabilities' },
  { name: 'Equity', key: 'equity' },
  { name: 'Revenues', key: 'revenues' },
  { name: 'Expenses', key: 'expenses' },
  { name: 'Accruals & Deferrals', key: 'accruals_deferrals' },
  { name: 'Contra-Accounts', key: 'contra_accounts' }
];